import data_control from "../../../../../engines/libs/data_control";
import { oreV2Interface } from "./oreV2Const";

const {ccclass, property} = cc._decorator;

@ccclass
export default class oreSelectItem extends cc.Component {

    oreV2Item:oreV2Interface = null;

    clickFun:(node:cc.Node,dataIndex:number)=>void = null;

    @property({type:cc.Label,displayName:"价格文本"})
    lbPrice:cc.Label = null;

    @property({type:cc.Label,displayName:"名字文本"})
    lbName:cc.Label = null;

    dataIndex:number = 0;

    //绑定数据
    bindData(oreV2Item:oreV2Interface,clickFun:(node:cc.Node)=>void,dataIndex:number){
        this.oreV2Item = oreV2Item;
        this.dataIndex = dataIndex;
        this.clickFun = clickFun;
        this.updateItem();
    }

    onBtnMe(){
        this.clickFun && this.clickFun(this.node,this.dataIndex);
    }

    //更新item
    updateItem(){
        if(this.oreV2Item){
            this.lbName.string = this.oreV2Item.name;
            this.lbPrice.string = data_control.getNumberFormat(this.oreV2Item.price);
        }
    }

}
